import { Color } from "antd/es/color-picker";
import { CFCDN } from "../shop-front-component/ProductCollection";



export interface colourType {
    title: string;
    src: string;
}
export const RickyPrivacyImages = [
    {
        title:'401 Gunmetal',
        src: CFCDN+"ricky-privacy/Mode+Privacy_401+Gunmetal.jpg",
    },
    {
        title:'402 Chestnut',
        src: CFCDN+"ricky-privacy/Mode Privacy_402+Chestnut.jpg",
    },
    {
        title:'403 Storm',
        src: CFCDN+"ricky-privacy/Mode Privacy_403+Storm.jpg",
    },
    {
        title:'404 Paperbark',
        src: CFCDN+"ricky-privacy/Mode+Privacy_404+Paperbark.jpg",
    },
    {
        title:'406 Desert',
        src: CFCDN+"ricky-privacy/Mode+Privacy_406+Desert.jpg",
    },
    {
        title:'407 Black Opal',
        src: CFCDN+"ricky-privacy/Mode+Privacy_407+Black+Opal.jpg",
    },
    {
        title:'408 Shadow',
        src: CFCDN+"ricky-privacy/Mode+Privacy_408+Shadow.jpg",
    },
    {
        title:'409 Colarado',
        src: CFCDN+"ricky-privacy/Mode Privacy_409 Colarado.jpg",
    },
    {
        title:'411 Basalt',
        src: CFCDN+"ricky-privacy/Outlook Privacy_411 Basalt.jpg",
    },
    {
        title:'412 Monument',
        src: CFCDN+"ricky-privacy/Outlook Privacy_412 Monument.jpg",
    },
]

export const RickyZeroImages = [
    {
        title:'517 Chalk',
        src: CFCDN+"ricky-zero/Mode Zero-517 Chalk.jpg",
    },
    {
        title:'541 Basalt',
        src: CFCDN+"ricky-zero/Mode Zero-541 Basalt.jpg",
    },
    {
        title:'542 Monument',
        src: CFCDN+"ricky-zero/Mode Zero-542 Monument.jpg",
    },
    {
        title:'553 Blackstone',
        src: CFCDN+"ricky-zero/Mode Zero-553 Blackstone.jpg",
    },
    {
        title:'564 Platinum',
        src: CFCDN+"ricky-zero/Mode Zero-564 Platinum.jpg",
    },
    {
        title:'566 Alpaca',
        src: CFCDN+"ricky-zero/Mode Zero-566 Alpaca.jpg",
    }
]


export const Ricky5Images = [
    {
        title:'502 Surfmist',
        src: CFCDN+"ricky-5/Outlook Mode_502 Surfmist.jpg",
    },
    {
        title:'503 Deep Sea',
        src: CFCDN+"ricky-5/Outlook Mode_503 Deep Sea.jpg",
    },
    {
        title:'504 Spice',
        src: CFCDN+"ricky-5/Outlook Mode_504 Spice.jpg",
    },
    {
        title:'505 Silver Sky',
        src: CFCDN+"ricky-5/Outlook Mode_505 Silver Sky.jpg",
    },
    {
        title:'507 Bamboo',
        src: CFCDN+"ricky-5/Outlook Mode_507 Bamboo.jpg",
    },
    {
        title:'508 Nougat',
        src: CFCDN+"ricky-5/Outlook Mode_508 Nougat.jpg",
    },
    {
        title:'509 Flint',
        src: CFCDN+"ricky-5/Outlook Mode_509 Flint.jpg",
    },
    {
        title:'510 Moonlight',
        src: CFCDN+"ricky-5/Outlook Mode_510 Moonlight.jpg",
    },
    {
        title:'511 Macchiato',
        src: CFCDN+"ricky-5/Outlook Mode_511 Macchiato.jpg",
    },
    {
        title:'517 Chalk',
        src: CFCDN+"ricky-5/Outlook Mode_517 Chalk.jpg",
    },
    {
        title:'526 Greystone',
        src: CFCDN+"ricky-5/Outlook Mode_526 Greystone.jpg",
    },
    {
        title:'529 Wheat',
        src: CFCDN+"ricky-5/Outlook Mode_529 Wheat.jpg",
    },
    {
        title:'533 Mocha',
        src: CFCDN+"ricky-5/Outlook Mode_533 Mocha.jpg",
    },
    {
        title:'538 Windspray',
        src: CFCDN+"ricky-5/Outlook Mode_538 Windspray.jpg",
    },
    {
        title:'542 Monument',
        src: CFCDN+"ricky-5/Outlook Mode_539 Shale Grey.jpg",
    },
    {
        title:'553 Blackstone',
        src: CFCDN+"ricky-5/Outlook Mode_540 Woodland Grey.jpg",
    },
    {
        title:'564 Platinum',
        src: CFCDN+"ricky-5/Outlook Mode_541 Basalt.jpg",
    },
    {
        title:'542 Monument',
        src: CFCDN+"ricky-5/Outlook Mode_542 Monument.jpg",
    },
    {
        title:'544 Eclipse',
        src: CFCDN+"ricky-5/Outlook Mode_544 Eclipse.jpg",
    },
    {
        title:'551 Ash',
        src: CFCDN+"ricky-5/Outlook Mode_551 Ash.jpg",
    },
    {
        title:'553 Blackstone',
        src: CFCDN+"ricky-5/Outlook Mode_553 Blackstone.jpg",
    },
    {
        title:'559 Forest Green',
        src: CFCDN+"ricky-5/Outlook Mode_559 Forest Green.jpg",
    },
    {
        title:'564 Platinum',
        src: CFCDN+"ricky-5/Outlook Mode_564 Platinum.jpg",
    },
    {
        title:'566 Alpaca',
        src: CFCDN+"ricky-5/Outlook Mode_566 Alpaca.jpg",
    },
    {
        title:'572 Porcelain',
        src: CFCDN+"ricky-5/Outlook Mode_572 Porcelain.jpg",
    },
    {
        title:'575 Marzipan',
        src: CFCDN+"ricky-5/Outlook Mode_575 Marzipan.jpg",
    },
    {
        title:'580 Pale Eucalypt',
        src: CFCDN+"ricky-5/Outlook Mode_580 Pale Eucalypt.jpg",
    },
    {
        title:'597 Maroon',
        src: CFCDN+"ricky-5/Outlook Mode_597 Maroon.jpg",
    }
]


export const protectaCatalogsZipImages = [
    {
        title: 'RickModePrivacyZERO',
        id: 155,
        desc: ['Provides exceptional weather protection and prevents insect.','Blocks out sunlight completely.','Ensures privacy with no visibility through.'],
        colours: RickyZeroImages,
        src:  "https://www.rickyrichards.com.au/Images/ProductImages/Large/outlookzero.png",
    },
    {
        title: 'RickModePrivacy1%',
        id: 156,
        desc: ['Provides weather, insects protection with 1% openness.','Allows for moderate airflow.','Offers partial views from inside and ensures privacy.'],
        colours: RickyPrivacyImages,
        src: "https://www.rickyrichards.com.au/Images/ProductImages/Large/ricky-outlookprivacy5.png",
    },
    {
        title: 'RickyOutlookMode5%',
        id: 158,
        desc: ['Allows for adequate ventilation with a 5% open design.','Maintains clear visibility with minimal obstruction at 5% openness.'],
        colours: Ricky5Images,
        
        src: "https://www.rickyrichards.com.au/Images/ProductImages/Large/ricky-outlookmode6.png",
    }
]



export const protectaSystemColor= [
    {id: 3, title: "Black", color:"#121212"}, 
    {id: 14, title: "Monument", color:"#474847"},
    {id: 22, title: "Slate Grey (W.G)", color:"#464a47"}, 
    // {id: 21, title: "Silver Pearl", color: "#d2d2d2"},
    {id: 1, title: "White", color:"#ffffff"},
    {id: 2, title: "Cream", color:"#e3d1b0"}, ] 


    export const protectaSystemHoodColor= [
        {id: 3, title: "Black", color:"#121212",src:CFCDN+'protecta-hood-color/black.png'}, 
        {id: 14, title: "Monument", color:"#474847",src:CFCDN+'protecta-hood-color/monument.png'},
        {id: 22, title: "Slate Grey (W.G)", color:"#464a47",src:CFCDN+'protecta-hood-color/slate-grey.png'}, 
        
        {id: 1, title: "White", color:"#ffffff",src:CFCDN+'protecta-hood-color/white.png'},
        {id: 2, title: "Cream", color:"#e3d1b0",src:CFCDN+'protecta-hood-color/cream.png'}, ] 


    export const protectaSystemChannelColor= [
        {id: 3, title: "Black", color:"#121212",src:CFCDN+'protecta-channel-color/black.png'}, 
        {id: 14, title: "Monument", color:"#474847",src:CFCDN+'protecta-channel-color/monument.png'},
        {id: 22, title: "Slate Grey (W.G)", color:"#464a47",src:CFCDN+'protecta-channel-color/slate-grey.png'}, 
      
        {id: 1, title: "White", color:"#ffffff",src:CFCDN+'protecta-channel-color/white.png'},
        {id: 2, title: "Cream", color:"#e3d1b0",src:CFCDN+'protecta-channel-color/cream.png'}, ] 

    export const protectaSystemBottomColor= [
            {id: 3, title: "Black", color:"#121212",src:CFCDN+'protecta-bottom/black.png'}, 
            {id: 14, title: "Monument", color:"#474847",src:CFCDN+'protecta-bottom/monument.png'},
            {id: 22, title: "Slate Grey (W.G)", color:"#464a47",src:CFCDN+'protecta-bottom/slate-grey.png'}, 
     
            {id: 1, title: "White", color:"#ffffff",src:CFCDN+'protecta-bottom/white.png'},
            {id: 2, title: "Cream", color:"#e3d1b0",src:CFCDN+'protecta-bottom/cream.png'}, ] 

    export const protectaOperarions = [ {id: 239, description: "8:1 Steck gearbox"},
        {id: 233, description: "ALPHA - Manual Overdrive"}, 
        {id: 234, description: "ALPHA - Obstacle Detection"}, 
        {id: 232, description: "ALPHA - Remote"}, 
        {id: 231, description: "ALPHA - Switch"},
        {id: 173, description: "CW - Manual Overdride"},
        {id: 172, description: "CW - Remote"},
        {id: 171, description: "CW - Switch"}, 
        {id: 240, description: "Gearbox 9:1"},
        {id: 170, description: "Manual"},
        {id: 176, description: "SIMU - Manual Overdrive"}, 
        {id: 175, description: "SIMU - Remote"},
        {id: 174, description: "SIMU - Switch"}, 
        {id: 237, description: "SOMFY - Manual Overdrive"}, 
        {id: 238, description: "SOMFY - Obstacle Detection"},
        {id: 236, description: "SOMFY - Remote"}, 
        {id: 235, description: "SOMFY - Switch"},
        {id: 177, description: "Spring Loaded LHS"}]

    export const controlType = [
        {title: "Manual",src:CFCDN+'protecta/control/settings.png'},
        {title: "Motorise",src:CFCDN+'protecta/control/controller.png'},
        {title: "Spring Loaded",src:CFCDN+'protecta/control/flexibility.png'}
    ]
    export const CWSelection = [
        {title: "CW 1 Channel Remote",src:CFCDN+'protecta/control/cw-1-channel_prev_ui.png'},
        {title: "CW 5 Channel Remote",src:CFCDN+'protecta/control/cw-5-channel_prev_ui.png'},
        {title: "CW 8 Channel Remote",src:CFCDN+'protecta/control/cw-8-channel_prev_ui.png'},
        {title: "CW 15 Channel Remote",src:CFCDN+'protecta/control/cw-15-channel_prev_ui.png'},
        {title: "CW 1 Channel Switch",src:CFCDN+'protecta/control/cw-switch-1_prev_ui.png'},
        {title: "CW 5 Channel Switch",src:CFCDN+'protecta/control/cw-switch-5_prev_ui.png'}
    ]
    export const AlphaSelection = [
        {title: "Alpha 1 Channel Remote",src:CFCDN+'protecta/control/alpha-1-channel.jpg'},
        {title: "Alpha 2 Channel Remote",src:CFCDN+'protecta/control/alpha-2-channel.jpg'},
        {title: "Alpha 5 Channel Remote",src:CFCDN+'protecta/control/alpha-5-channel.jpg'},
        {title: "Alpha 8 Channel Remote",src:CFCDN+'protecta/control/alpha-8-channel.jpg'},
        {title: "Alpha 16 Channel Remote",src:CFCDN+'protecta/control/alpha-16-channel.jpg'},
        {title: "Alpha 1 Channel Switch",src:CFCDN+'protecta/control/alpha-sw-1-channel.jpg'},
        {title: "Alpha 2 Channel Switch",src:CFCDN+'protecta/control/alpha-sw-2-channel.jpg'},
        {title: "Alpha 8 Channel Switch",src:CFCDN+'protecta/control/alpha-switch-8-channel.jpg'}
    ]
    export const simuSelection = [
        {title: "Simu 1 Channel Remote",src:CFCDN+'protecta/control/simu-1-channel.png'},
        {title: "Simu 5 Channel Remote",src:CFCDN+'protecta/control/simu-5-channel.png'},
        {title: "Simu 16 Channel Remote",src:CFCDN+'protecta/control/simu-16-channel.png'},
        {title: "Simu 1 Channel Switch",src:CFCDN+'protecta/control/simu-sw-1-channel.png'},
        {title: "Simu 5 Channel Switch",src:CFCDN+'protecta/control/simu-sw-5-channel.png'},
       
    ]
    export const SomfySelection = [
        {title: "Somfy 1 Channel Remote",src:CFCDN+'protecta/control/somfy-1-channel.avif'},
        {title: "Somfy 2 Channel Remote",src:CFCDN+'protecta/control/somfy-2-channel.avif'},
        {title: "Somfy 5 Channel Remote",src:CFCDN+'protecta/control/somfy-5-channel.avif'},
        {title: "Somfy 16 Channel Remote",src:CFCDN+'protecta/control/somfy-16-channel.avif'},
        {title: "Somfy 1 Channel Switch",src:CFCDN+'protecta/control/somfy-sw-1-channel.avif'},
        {title: "Somfy 2 Channel Switch",src:CFCDN+'protecta/control/somfy-sw-2-channel.avif'},
        {title: "Somfy 4 Channel Switch",src:CFCDN+'protecta/control/somfy-sw-4-channel.avif'}
    ]
    export const motoBrand = [
        {title: "CW",src:CFCDN+'awning-motor-brand/cw-square.jpg', controls: CWSelection},
        {title: "ALPHA",src:CFCDN+'awning-motor-brand/alpha-square.jpg', controls: AlphaSelection},
        {title: "SIMU",src:CFCDN+'awning-motor-brand/simu-logo.png', controls: simuSelection},
        {title: "SOMFY",src:CFCDN+'awning-motor-brand/somfy.jpg', controls: SomfySelection}
    ]
    